/**
 * Bestsellers Section - Tab Switching Component
 * Custom element for handling tab navigation in the bestsellers section.
 */

class BestsellersTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = [];
    this.panels = [];
    this.activeIndex = 0;
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    if (this.tabs.length === 0 || this.panels.length === 0) return;

    this.bindEvents();
  }

  bindEvents() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activateTab(index));
      tab.addEventListener('keydown', (e) => this.handleKeydown(e, index));
    });
  }

  activateTab(index) {
    if (index === this.activeIndex) return;

    // Update the "View All" button URL
    const activeTab = this.tabs[index];
    const collectionUrl = activeTab.getAttribute('data-collection-url');
    const sectionId = this.closest('.shopify-section').id.replace('shopify-section-', '');
    const viewAllButton = document.getElementById(`bestsellers-view-all-${sectionId}`);
    
    if (viewAllButton && collectionUrl) {
      viewAllButton.setAttribute('href', collectionUrl);
    }

    // Deactivate current tab
    this.tabs[this.activeIndex].classList.remove('bestsellers-section__tab--active');
    this.tabs[this.activeIndex].setAttribute('aria-selected', 'false');
    this.panels[this.activeIndex].classList.remove('bestsellers-section__tab-panel--active');
    this.panels[this.activeIndex].hidden = true;

    // Activate new tab
    this.tabs[index].classList.add('bestsellers-section__tab--active');
    this.tabs[index].setAttribute('aria-selected', 'true');
    this.panels[index].classList.add('bestsellers-section__tab-panel--active');
    this.panels[index].hidden = false;

    this.activeIndex = index;
  }

  handleKeydown(event, currentIndex) {
    let newIndex;

    switch (event.key) {
      case 'ArrowLeft':
        event.preventDefault();
        newIndex = currentIndex === 0 ? this.tabs.length - 1 : currentIndex - 1;
        break;
      case 'ArrowRight':
        event.preventDefault();
        newIndex = currentIndex === this.tabs.length - 1 ? 0 : currentIndex + 1;
        break;
      case 'Home':
        event.preventDefault();
        newIndex = 0;
        break;
      case 'End':
        event.preventDefault();
        newIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    this.tabs[newIndex].focus();
    this.activateTab(newIndex);
  }
}

// Register the custom element
if (!customElements.get('bestsellers-tabs')) {
  customElements.define('bestsellers-tabs', BestsellersTabs);
}


